import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { NavLink, useLocation } from "react-router-dom";
import { data } from "../../common/constants";
import { sidelogo, SidePic } from "../../../assets/exports";

const Sidebar = () => {
  const activeStyle = {
    backgroundColor: "#E2D7F4",
    alignItems: "center",
    display: "flex",
    color: "#828282",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    margin: "6px 0",
    padding: "10px",
    height: "45px",
    borderRadius: "10px",
  };
  const location = useLocation();

  return (
    <Flex
      flexDir="column"
      justifyContent="space-between"
      position={"fixed"}
      minH="100vh"
      zIndex="5"
      w="240px"
      bgColor="semiPurple"
      px="20px"
      pt={5}
    >
      <Box>
        <Image src={sidelogo} w="154px" h="45px" alt="logo" />
      </Box>
      <Box
        borderTop="1px solid #7B47CC"
        pt="25px"
        mt={7}
        pos="relative"
        zIndex="99"
      >
        {data.map((item) => (
          <Box
            key={item.path}
            _hover={{ backgroundColor: "#E2D7F4", borderRadius: "10px" }}
          >
            <NavLink
              to={item.path}
              style={({ isActive }) =>
                isActive
                  ? { ...activeStyle, color: "#7B47CC", fontWeight: "600" }
                  : {
                      ...activeStyle,
                      backgroundColor: "",
                    }
              }
            >
              <Image
                src={location.pathname === item.path ? item.blue : item.icon}
                w="20px"
                h="20px"
                mr="3"
              />
              {item.name}
            </NavLink>
          </Box>
        ))}
      </Box>
      <Box mt="auto">
        <Image src={SidePic} w="195px" h="289px" />
      </Box>
    </Flex>
  );
};

export default React.memo(Sidebar);
